module.exports = __webpack_public_path__ + "asset/hallywood--ef862e.ttf";